const SupportIcon = () => {
  return (
    <svg
      className="header_icon"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path
        className="fill"
        d="M20 22C20 19.7909 21.7909 18 24 18C26.2091 18 28 19.7909 28 22V26C28 28.2091 26.2091 30 24 30C21.7909 30 20 28.2091 20 26V22Z"
        fill="#17171C"
      />
      <path
        className="fill"
        d="M30 22C30 21.4477 30.4477 21 31 21H32C33.1046 21 34 21.8954 34 23V25C34 26.1046 33.1046 27 32 27H31C30.4477 27 30 26.5523 30 26V22Z"
        fill="#17171C"
      />
      <path
        className="fill"
        d="M14 23C14 21.8954 14.8954 21 16 21H17C17.5523 21 18 21.4477 18 22V26C18 26.5523 17.5523 27 17 27H16C14.8954 27 14 26.1046 14 25V23Z"
        fill="#17171C"
      />
      <path
        className="stroke"
        d="M17 22V22C17 18.134 20.134 15 24 15V15C27.866 15 31 18.134 31 22V26C31 29.866 27.866 33 24 33V33"
        stroke="#17171C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SupportIcon
